import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
const Nanobar = require('nanobar');

type AlertType = 'success' | 'error';

export interface CurrentAlertData {
  props: {
    type: string,
    message: string,
    onClose: () => void
  }
}

/**
 * Service to show alerts and progress
 */
@Injectable()
export class NotifierService {

  private _currentAlert = new Subject<CurrentAlertData>();

  constructor() {
  }

  get currentAlert() {
    return this._currentAlert;
  }

  set currentAlert(value) {
    // Ignore
  }

  // Shows alert
  alert(type: AlertType, message: string) {
    
    // Build a new alert data
    let alertData = {
      props: {
        type,
        message,
        onClose: () => {
          // Close the alert by sending empty alert data
          this._currentAlert.next();
        }
      }
    }

    // Show the new alert
    this._currentAlert.next(alertData);
  }

  success(message: string) {
    this.alert('success', message);
  }

  error(message: string) {
    this.alert('error', message);
  }


  private nanobar = new Nanobar();
  private amount: number = 0;
  
  get currentProgress() {
    return this.amount;
  }

  updateProgress(amount: number) {
    this.amount = amount;
    this.nanobar.go(amount);
  }

  startProgress() {
    this.updateProgress(10);
  }

  endProgress() {
    this.updateProgress(100);
  }
}